import AWS                        from 'aws-sdk';
import { store }                  from 'index';
import { objType }                from 'types';
import { DELETE_USER_VIDEO_SAGA } from 'actions/contentActions';
import { SET_COMPONENTS_STATE }   from 'actions/componentsActions';
import { componentsStateType }    from 'reducer/types';



const deleteVideo = async (videoId: string) => {

    const dev            = process.env.NODE_ENV === 'development';
    const BucketName     = "yisumatica-screen-recordings";
    const BucketRegion   = "us-east-2";
    const IdentityPoolId = "us-east-2:75049c47-68d0-45e0-a49d-49f7391b6195";

    const state              = store.getState();
    const userVideos         = state.content.userVideos;
    const componentsState    = state.components;
    let   newUserVideos      = userVideos;
    const deleteVideoSaga    = (payload: objType) => store.dispatch(DELETE_USER_VIDEO_SAGA(payload));
    const setComponentsState = (payload: componentsStateType) => store.dispatch(SET_COMPONENTS_STATE(payload));

    AWS.config.update({
      region: BucketRegion,
      credentials: new AWS.CognitoIdentityCredentials({
        IdentityPoolId: IdentityPoolId
      })
    });

    var params = {
      Bucket: BucketName, 
      Key: videoId
    };

    var s3 = new AWS.S3();

    try {
      if (!dev) {  
        s3.deleteObject(params, function(err, data) {
          if (err) console.log(err, err.stack); 
          else     console.log(data);
        });
      }

      if (userVideos.length === 1) {
        newUserVideos = []
      }

      else {
        for(let i = 0; i<userVideos.length; i++){
          if( userVideos[i].video_id === videoId ) {
            newUserVideos.splice(i, 1);
            break;
          }
        }
      }

      console.log('newUserVideos : ',newUserVideos)

      deleteVideoSaga({
        videoId:       videoId,
        newUserVideos: newUserVideos
      })

      setComponentsState({
        ...componentsState,
        sender:         'deleteVideo',
        showUserVideos: false
      })
   }

   catch (error) {
     console.error('video deletion message: error deleting file - - - ',error)
   }
   finally {
   }

}

export default deleteVideo;


    /* import { store } from 'index';
    import { SET_COMPONENTS_STATE } from 'actions/componentsActions';
    import { componentsStateType } from 'reducer/types';

    const closeVideoPlayer = () => {

        const state              = store.getState();
        const componentsState    = state.components;
        const setComponentsState = (payload: componentsStateType) => store.dispatch(SET_COMPONENTS_STATE(payload));

        setComponentsState({
          ...componentsState,
          showUserVideos: false
        })
    }

    export default closeVideoPlayer; */